import styled from "styled-components";

export const CenteredCircle = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
`;

export const ModalRoot = styled.div`
  height: 800px;
  flex-grow: 1;
  min-width: 300px;
  transform: translateZ(0);

  @media all and (-ms-high-contrast: none) {
    display: none;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
`;

export const ModalPaper = styled.div`
  width: 400px;
  color: var(--c1);
  background-color: #fff;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  padding: 16px 32px 24px;
  border-radius: 6px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const ToggleDescription = styled.div`
  padding: 10px;
`;

export const ToggleContainer = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: ${({ mode }) =>
    mode === "light" ? "flex-start" : "flex-end"};
  width: 120px;
  height: 36px;
  border-radius: 999px;
  cursor: pointer;
  background-color: ${({ mode }) => (mode === "light" ? "#e5e5e5" : "#000")};
  color: ${({ mode }) => (mode === "light" ? "#000" : "#fff")};
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 12px;
  position: relative;
`;

export const SwitchThumb = styled.div`
  background-color: ${({ mode }) => (mode === "light" ? "#fff" : "#1a1a1a")};
  border: 2px solid ${({ mode }) => (mode === "light" ? "#ccc" : "#fff")};
  width: 28px;
  height: 28px;
  border-radius: 50%;
  position: absolute;
  left: ${({ mode }) => (mode === "light" ? "4px" : "calc(100% - 38px)")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.3s ease;
`;

export const Label = styled.span`
  margin: 0 auto;
  z-index: 1;
`;
